export const CLASS = 
[
    {
        "id": 110,
        "teacherId": 1135,
        "title": "My Class",
        "std": "X",
        "coTeachers": [
            {
                "Id": "123",
                "Email":"abc@gmail.com"
            },
            {
                "Id": "124",
                "Email":"def@gmail.com"
            }],
        "students":[
            {
            "Name":"Nitesh Jha",
            "Email":"nitesh.jha1092@gmail.com"
            },
            {
            "Name":"Rohan Jha",
            "Email":"rohanjha796@gmail.com"
            }
        ],
        "sessions":[
            {
                "id": 10,
                "modId":5,
                "title": "How does the type of soil affect the drainage of water through soil",
                "groupType": "Homogeneous",
                "groupSize":4,
                "groups":[
                    {
                    "groupId":1,
                    "currentStatus":"Hypothesis"
                    },
                    {
                      "groupId":2,
                      "currentStatus":"Experiment"
                    },
                    {
                      "groupId":3,
                      "currentStatus":"Board"
                    }
                    ,
                    {
                      "groupId":4,
                      "currentStatus":"Forum"
                    }
                    ,
                    {
                      "groupId":5,
                      "currentStatus":"ReportWriting"
                    }
                    ,
                    {
                      "groupId":6,
                      "currentStatus":"PeerReview"
                    },
                    {
                      "groupId":7,
                      "currentStatus":"Hypothesis"
                    }
                ] ,
                "completed":false,
                "start": "2020-11-20T10:29:00.000Z"
            },
            {
                "id": 11,
                "modId":6,
                "title": "Factors that affect the swing of pendulum: mass of object at the end",
                "groupType": "Heterogeneous",
                "groupSize":4,
                "groups":[
                    {
                    "groupId":1,
                    "currentStatus":"Hypothesis"
                    },
                    {
                      "groupId":2,
                      "currentStatus":"Experiment"
                    },
                    {
                      "groupId":3,
                      "currentStatus":"Board"
                    }
                    ,
                    {
                      "groupId":4,
                      "currentStatus":"Forum"
                    }
                    ,
                    {
                      "groupId":5,
                      "currentStatus":"ReportWriting"
                    }
                    ,
                    {
                      "groupId":6,
                      "currentStatus":"PeerReview"
                    }
                ] ,
                "completed":false,
                "start": "2020-11-20T10:29:00.000Z"
            }
           
            
            
            
        ],
        "image":"/assets/images/time_of_rise.png",
        "session":false,
        "created": "2020-10-16"
    },
    {
        "id": 111,
        "teacherId": 1145,
        "title": "My New Class",
        "std": "XI",
        "coTeachers": [
                        {
                            "Id": "129",
                            "Email":"asdad@gmail.com"
                        },
                        {
                            "Id": "130",
                            "Email":"blabla@gmail.com"
                        },
                        {
                            "Id": "139",
                            "Email":"rohan@gmail.com"
                        }
                    ],
        "students":[
                        {
                        "Name":"Nitesh Jha",
                        "Email":"nitesh.jha1092@gmail.com"
                        },
                        {
                        "Name":"Rohan Jha",
                        "Email":"rohanjha796@gmail.com"
                        }
                    ],
        "sessions":[
                    {
                        "id": 10,
                        "modId":5,
                        "title": "How does the type of soil affect the drainage of water through soil",
                        "groupType": "Homogeneous",
                        "groupSize":4,
                        "groups":[
                            {
                            "groupId":1,
                            "currentStatus":"Hypothesis"
                            },
                            {
                              "groupId":2,
                              "currentStatus":"Experiment"
                            },
                            {
                              "groupId":3,
                              "currentStatus":"Board"
                            }
                            ,
                            {
                              "groupId":4,
                              "currentStatus":"Forum"
                            }
                            ,
                            {
                              "groupId":5,
                              "currentStatus":"ReportWriting"
                            }
                            ,
                            {
                              "groupId":6,
                              "currentStatus":"PeerReview"
                            }
                        ] ,
                        "completed":false,
                        "start": "2020-11-20T10:29:00.000Z"
                    },
                    {
                        "id": 12,
                        "modId":6,
                        "title": "Factors that affect the swing of pendulum: mass of object at the end",
                        "groupType": "Heterogeneous",
                        "groupSize":4,
                        "groups":[
                                    {
                                    "groupId":1,
                                    "currentStatus":"Experiment"
                                    },
                                    {
                                    "groupId":2,
                                    "currentStatus":"Experiment"
                                    },
                                    {
                                    "groupId":3,
                                    "currentStatus":"Board"
                                    }
                                     ,
                                    {
                                    "groupId":4,
                                    "currentStatus":"Forum"
                                    }
                                    ,
                                    {
                                    "groupId":5,
                                    "currentStatus":"ReportWriting"
                                    }
                                    ,
                                    {
                                    "groupId":6,
                                    "currentStatus":"PeerReview"
                                    },
                                    {
                                      "groupId":7,
                                      "currentStatus":"Hypothesis"
                                    }
                                ],
                            "completed":false,
                            "start": "2020-11-20T10:29:00.000Z"
                    }
                ],
                    "image":"/assets/images/time_of_rise.png",
                    "session":false,
                    "created": "2020-10-16"

    }    
];